<footer class="text-center text-lg-start steddie-footer">
  <div class="container text-center text-md-start pt-5">
    <div class="row mt-3">
      <div class="col-md-4 col-lg-4 col-xl-3 mx-auto mb-4">
        <h6 class="footer-header mb-4">Word jij een held?</h6>
        <p>Stichting Steddie kan jouw hulp goed gebruiken.</p>
        <p><a class="text-reset" [routerLink]="['/steun-steddie']">Kijk hier voor meer informatie...</a></p>
        <a class="text-reset" [routerLink]="['/steun-steddie']">
          <img src="assets/img/ANBI-logo-nieuw.png" alt="ANBI Logo" class="footer-image" width="100" height="80">
        </a>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-3 mx-auto mb-4">
        <h6 class="footer-header mb-4">Navigatie</h6>
        <p>
          <i class="bi bi-chevron-right"></i><a [routerLink]="['/contact']" class="text-reset">Over ons</a>
        </p>
        <p>
          <i class="bi bi-chevron-right"></i><a [routerLink]="['/account/inloggen']" class="text-reset">Inloggen</a>
        </p>
        <p>
          <i class="bi bi-chevron-right"></i><a [routerLink]="['/account/registreren']" class="text-reset">Registreren</a>
        </p>
        <p>
          <i class="bi bi-chevron-right"></i><a [routerLink]="['/activiteiten']" class="text-reset">Activiteiten</a>
        </p>
        <p>
          <i class="bi bi-chevron-right"></i><a [routerLink]="['/privacy']" class="text-reset">Privacy</a>
        </p>
        <p>
          <i class="bi bi-chevron-right"></i><a [routerLink]="['/faq']" class="text-reset">FAQ</a>
        </p>
        <p>
          <i class="bi bi-chevron-right"></i><a [routerLink]="['/steun-steddie']" class="text-reset">Steun Steddie</a>
        </p>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-3 mx-auto mb-4">
        <h6 class="footer-header mb-4">Contact</h6>
        <p>Kwikstaartlaan 49</p>
        <p>1826 GB Alkmaar</p>
        <p>info&#64;steddie.nl</p>
        <p><a class="text-light" href="tel:072-5314614">072- 5 314 614</a></p>
      </div>
    </div>
    <p class="text-center">KvK 88994783</p>
  </div>
  <div class="bottom-banner">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-6 col-xl-6 m-4 mx-auto text-start">
          Copyright © {{ currentYear }} Alle rechten voorbehouden | Steddie
        </div>
        <div class="col-md-6 m-4 mx-auto text-end social-media-wrap">
          <div class="social-media-icons">
            <a href="https://www.linkedin.com/company/82112832/" target="_blank" aria-label="Onze LinkedIn pagina" rel="noopener noreferrer"><i class="bi bi-linkedin"></i></a>
            <a href="https://www.facebook.com/profile.php?id=100082982754500" aria-label="Onze Facebook pagina" target="_blank" rel="noopener noreferrer"><i class="bi bi-facebook"></i></a>
            <a href="https://www.instagram.com/p/CqBbkEeIVPX/?igshid=NDNjYmRhZmQ=" aria-label="Onze Instagram pagina" target="_blank" rel="noopener noreferrer"><i class="bi bi-instagram"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
